import React from 'react';
import { Redirect } from 'react-router-dom';

import SuccessDialog from '../../components/Popups/SuccessDialog/SuccessDialog';
import FailureDialog from '../../components/Popups/FailureDialog/FailureDialog';
import DownloadDialog from '../../components/Popups/DownloadDialog/DownloadDialog';
import NoInternet from '../../components/NoInternet/NoInternet';

import ShowLoader from '../ShowLoader/ShowLoader';
import RouteEndPoints from '../../utilities/RouteEndPoints';
import AlertDialog from '../../components/Popups/AlertDialog/AlertDialog';
import ConfirmationDialog from '../../components/Popups/ConfirmationDialog/ConfirmationDialog';

const redirectUtilityWrapper = (props) => {
    return (
        props.isLoading ? <ShowLoader isLoading={props.isLoading} showMessage={props.showMessage} /> :
            <div>
                {props.somethingWentWrong ? <Redirect to={RouteEndPoints.SERVER_ERROR} /> : null}
                {props.notFound ? <Redirect to={RouteEndPoints.NOT_FOUND} /> : null}
                {props.unauthorized ? <Redirect to={RouteEndPoints.UNAUTHORIZED_ERROR} /> : null}
                <DownloadDialog
                    show={props.showDownloadDialog}
                    message={props.downloadDialogMessage}
                    buttonLabel={props.downloadDialogButtonLabel}
                    targetUrl={props.targetUrl}
                    buttonClicked={props.onDownloadDialogHide} />
                <SuccessDialog
                    show={props.showSuccessDialog}
                    message={props.successDialogMessage}
                    buttonLabel={props.successDialogButtonLabel}
                    buttonClicked={props.onSuccessDialogHide} />
                <FailureDialog
                    show={props.showFailureDialog}
                    message={props.failureDialogMessage}
                    buttonLabel={props.failureDialogButtonLabel}
                    buttonClicked={props.onFailureDialogHide} />
                <AlertDialog
                    show={props.showAlertDialog}
                    message={props.alertDialogMessage}
                    buttonLabel={props.alertDialogButtonLabel}
                    buttonClicked={props.onAlertDialogHide} />
                <ConfirmationDialog
                    showLoading={props.showDialogLoader}
                    show={props.showConfirmationDialog}
                    message={props.confirmationDialogMessage}
                    secondaryButtonLabel={props.confirmationSecondaryButtonLabel}
                    secondaryButtonClick={props.confirmationSecondaryButtonClick}
                    primaryButtonLabel={props.confirmationPrimaryButtonLabel}
                    primaryButtonClicked={props.confirmationPrimaryButtonClicked} />
                {props.noInternet ? <NoInternet /> : props.children}
            </div>
    );
}

export default redirectUtilityWrapper;